export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: "Comment je reçois le pack après l'achat ?",
    a: "Tu reçois un accès immédiat à tout le matériel pour commencer à l'utiliser tout de suite — sans attente, sans étapes compliquées. Tout se télécharge en fichiers PDF prêts à ouvrir, lire et enseigner.",
  },
  {
    q: "Pour quel niveau de professeur d'espagnol est-ce fait ?",
    a: "Prof d'Espagnol Prêt est conçu pour tout professeur francophone qui enseigne l'espagnol — que tu sois en début de carrière ou expérimenté. Si tu enseignes Spanish 1 ou Spanish 2 et tu veux arrêter de construire tes cours de zéro, ce système est fait pour toi.",
  },
  {
    q: 'Ça fonctionne pour les professeurs dans tous les pays ?',
    a: "Oui. France, Belgique, Suisse, Québec, Maroc, Tunisie, Afrique francophone — le système est conçu pour tout professeur francophone qui enseigne l'espagnol, quel que soit le pays ou le système scolaire.",
  },
  {
    q: 'Est-ce que je peux modifier le matériel ?',
    a: "Le matériel est fourni en PDF pour une utilisation simple et immédiate. Il est conçu pour fonctionner directement en classe, sans modification nécessaire.",
  },
  {
    q: 'Dans quelle monnaie vais-je payer ?',
    a: 'Tu paies dans ta devise locale. Le montant s’ajuste automatiquement selon ton pays. Tu verras le prix exact dans ta monnaie avant de confirmer.',
  },
  {
    q: 'Et si ça ne me convient pas ?',
    a: "Garantie complète de remboursement dans les 7 jours. Tu explores tout le système, tu utilises le matériel en classe, et si tu n'es pas satisfait — tu contactes le support et tu es intégralement remboursé, sans questions posées.",
  },
]
